/**
 * Conta AWS integrada ao CUDOS — tela `2b`, Configurações de FinOps.
 *
 * Vive DENTRO do módulo e não em Administração: BR-26, configuração POR CLIENTE
 * mora no módulo, só a global fica em Administração.
 *
 * 🔴 **O estado de falha carrega a mensagem REAL da AWS.** Pedido explícito do
 * Eduardo na sessão de frontend: a tela mostra o erro que a AWS devolveu, e não
 * um ícone vermelho mudo. `mensagemErro` é a string crua; `acaoSugerida` é a
 * orientação derivada do `codigoErro` — e vem `null` quando o código é
 * desconhecido, porque chutar orientação errada manda o arquiteto investigar o
 * lugar errado.
 */
import { z } from 'zod'

import { id, valorDeCatalogo } from './comum'

export const contaAwsSchema = z.object({
  idCliente: id,
  /** 12 dígitos, com os zeros à esquerda preservados. Nunca número. */
  accountId: valorDeCatalogo,
  apelido: z.string(),
  ativa: z.boolean(),

  statusConectividade: z.enum(['ok', 'falha', 'nao_verificado']),
  /** Código estável, para agrupar e alertar: `AccessDenied`, `NoSuchBucket`. */
  codigoErro: z.string().nullable(),
  /** 🔴 A string CRUA que a AWS devolveu. */
  mensagemErro: z.string().nullable(),
  /** A sub-linha "o que fazer" da `2b`. `null` = código desconhecido. */
  acaoSugerida: z.string().nullable(),
  verificadoEm: z.string().nullable(),

  /** A coluna "Última leitura (parquet / Athena)" da `2b`. */
  ultimaLeituraParquet: z.string().nullable(),
  ultimaParticaoParquet: z.string().nullable(),
})

export type ContaAws = z.infer<typeof contaAwsSchema>

export const respostaDeContasSchema = z.object({
  itens: z.array(contaAwsSchema),
  /** Gating de UX, nunca fronteira de segurança (BR-17): o servidor recusa a
   *  escrita de qualquer jeito. Vem daqui para a tela não reimplementar a união
   *  de grupos só para decidir se mostra um botão. */
  podeEditar: z.boolean(),
})

export type RespostaDeContas = z.infer<typeof respostaDeContasSchema>

export const verificacaoSchema = z.object({
  status: z.enum(['ok', 'falha']),
  codigoErro: z.string().nullable(),
  mensagemErro: z.string().nullable(),
  duracaoMs: z.number().nullable(),
  verificadoEm: z.string(),
})

export type Verificacao = z.infer<typeof verificacaoSchema>
